export default __webpack_public_path__ + "CircularCustCapNum-Medium.d9c18cffbd576435829943b15d4ca8fe.woff";